module.exports = __webpack_public_path__ + "img/category-favorite-hover.d2b245c8.png";